import {FiArrowUpRight} from "react-icons/fi";
import {PROFILE} from "../../data/resume";

export const ContactSection = () => (
    <section id="contact" className="contact-section" aria-labelledby="contact-title">
        <div className="shell contact-layout">
            <div><h2 id="contact-title">Have something<br />worth building?</h2><p>I’m open to founding and startup engineering, senior frontend, backend, and full-stack roles where product judgment and hands-on delivery matter.</p>
                <a className="action action-light" href={PROFILE.bookingUrl} target="_blank" rel="noopener noreferrer">Book a 30-min call <FiArrowUpRight aria-hidden="true" /></a>
            </div>
            <div className="contact-details">
                <a className="contact-email" href={`mailto:${PROFILE.email}`}>{PROFILE.email}<FiArrowUpRight aria-hidden="true" /></a>
                <a href={PROFILE.phoneHref}>{PROFILE.phone}</a>
                <p>{PROFILE.location} · Open to remote · Open to relocation</p>
                <p>U.S. citizen · Authorized to work in the United States</p>
                <div className="contact-social"><a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn <FiArrowUpRight aria-hidden="true" /></a><a href={PROFILE.github} target="_blank" rel="noopener noreferrer">GitHub <FiArrowUpRight aria-hidden="true" /></a></div>
            </div>
        </div>
    </section>
);
